import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const StaffingHero = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="relative pt-32 pb-24 px-6 overflow-hidden">
      <div className="relative z-20 max-w-7xl mx-auto">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            <span className="text-gray-400">Staffing & Recruiting Teams</span>
            <br />
            <span className="text-white">Move Talent Forward—Faster</span>
          </h1>

          <p className="text-xl md:text-2xl text-cyan-400 font-semibold mb-6">
            Powered by Traain AI
          </p>

          <p className="text-lg md:text-xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed">
            Prepare placed talent, standardize readiness, and deliver client-ready professionals at scale.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              onClick={openCalendly}
              className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
            >
              See Traain for Staffing & Recruiting
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default StaffingHero;
